export const SET_ALL = (state, data) => {
  state.items = data;
};
